import cbor from "cbor";

export const convertBase64ToArrayBuffer = (base64) => {
  const binaryString = window.atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
};

export const convertArrayBufferToBase64 = (buffer) => {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  const base64 = window.btoa(binary);
  return base64;
};

export const convertStringToArrayBuffer = (str) => {
  const encoder = new TextEncoder();
  return encoder.encode(str);
};

export const combineArrayBuffers = (buffer1, buffer2) => {
  const combined = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
  combined.set(new Uint8Array(buffer1), 0);
  combined.set(new Uint8Array(buffer2), buffer1.byteLength);
  return combined.buffer;
};

export const arrayBufferToJSON = (arrayBuffer) => {
  // Step 1: Convert the ArrayBuffer to Uint8Array
  const uint8Array = new Uint8Array(arrayBuffer);

  // Step 2: Decode the Typed Array into a string
  const decoder = new TextDecoder("utf-8");
  const jsonString = decoder.decode(uint8Array);

  // Step 3: Parse the String as JSON
  try {
    const jsonObject = JSON.parse(jsonString);
    return jsonObject;
  } catch (e) {
    console.error("The string is not valid JSON", e);
    // Handle the error as appropriate for your application
  }
};

export const arrayBufferToCBOR = async (arrayBuffer) => {
  try {
    const decodedData = await cbor.decodeFirst(arrayBuffer);
    return decodedData;
  } catch (err) {
    console.error("Error decoding CBOR:", err);
    return null;
  }
};

export const decodeAuthenticatorData = (buffer) => {
  const dataView = new DataView(buffer);
  let offset = 0;

  const rpIdHash = buffer.slice(offset, offset + 32);
  offset += 32;

  const flags = dataView.getUint8(offset);
  offset += 1;

  const userPresent = (flags & 0x01) !== 0;
  const userVerified = (flags & 0x04) !== 0;
  const hasAttestedCredentialData = (flags & 0x40) !== 0;
  const hasExtensionData = (flags & 0x80) !== 0;

  const signatureCounter = dataView.getUint32(offset, false);
  offset += 4;

  let attestedCredentialData = null;
  if (hasAttestedCredentialData) {
    const aaguid = buffer.slice(offset, offset + 16);
    offset += 16;

    const credentialIdLength = dataView.getUint16(offset, false);
    offset += 2;

    const credentialId = buffer.slice(offset, offset + credentialIdLength);
    offset += credentialIdLength;

    // The public key is in COSE format and requires additional parsing
    // You'll need to use a COSE library to parse it
    const publicKeyCOSE = buffer.slice(offset); // Remaining buffer

    attestedCredentialData = {
      aaguid,
      credentialId,
      publicKeyCOSE,
    };
  }

  let extensionData = null;
  if (hasExtensionData) {
    // Parse the extension data as required
    // The format and parsing depend on the specific extensions used
  }

  return {
    rpIdHash,
    flags: {
      userPresent,
      userVerified,
      hasAttestedCredentialData,
      hasExtensionData,
    },
    signatureCounter,
    attestedCredentialData,
    extensionData,
  };
};
